import { defineNuxtPlugin, useNuxtApp } from 'nuxt/app';
import colors from '~~/common/assets/styles/variables/colors.module.scss';
import awUserInterface from '~~/common/assets/styles/variables/aw-user-interface.module.scss';
import grids from '~~/common/assets/styles/variables/grids.module.scss';

const styleVariables = {
  ...colors,
  ...awUserInterface,
  ...grids,
};

function createPluginProvides () {
  const nuxtApp = useNuxtApp();
  const styleVariablesProxy = new Proxy(
    styleVariables,
    {
      get (obj, key) {
        const value = typeof key === 'string' ? (obj as Record<string, unknown>)[key] : undefined;
        if (value === undefined && !String(key).startsWith('__v') && !String(key).startsWith('Symbol')) {
          const logger = nuxtApp.$logger;
          (logger || console).error(`Style variable ${String(key)} not found.`);
        }
        return value;
      },
    },
  );

  return {
    styleVariables: styleVariablesProxy,
  };
}

export type StyleVariablesPluginProvides = ReturnType<typeof createPluginProvides>;

export default defineNuxtPlugin(() => {
  return {
    provide: createPluginProvides(),
  };
});
